/*
  Adopts quiz-overrides.css into the RevenueHunt quiz's shadow root.

  The quiz mounts as <div id="shadow-quiz"> with an open shadow root, and it is
  created lazily — only once the popup is first opened. Page-level CSS cannot
  cross the shadow boundary, so we hand the stylesheet to the shadow root
  directly via adoptedStyleSheets. Adopted sheets live on the ShadowRoot itself
  rather than in its child list, so they survive the app re-rendering its
  contents between questions.
*/
(() => {
  const script = document.currentScript;
  const cssUrl = script && script.dataset.quizCss;
  if (!cssUrl) return;

  let sheetPromise;

  function getSheet() {
    if (!sheetPromise) {
      sheetPromise = fetch(cssUrl)
        .then((res) => res.text())
        .then((css) => {
          const sheet = new CSSStyleSheet();
          sheet.replaceSync(css);
          return sheet;
        })
        .catch(() => null);
    }
    return sheetPromise;
  }

  function adopt(root) {
    if (!root || root.__ctQuizStyled) return;
    root.__ctQuizStyled = true;
    getSheet().then((sheet) => {
      if (!sheet || root.adoptedStyleSheets.includes(sheet)) return;
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    });
  }

  function scan() {
    document.querySelectorAll('#shadow-quiz').forEach((host) => adopt(host.shadowRoot));
  }

  /* The quiz mutates its own DOM constantly as you move between questions, so
     coalesce the observer's callbacks into one scan per frame. */
  let queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  }

  if (!('adoptedStyleSheets' in Document.prototype)) return;

  scan();
  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
